import { StateCreator } from 'zustand';
import { UserData } from '../../types/user.types';
import {
  ACCESSTOKEN_LOCALSTORAGE_KEY,
  PROFILE_LOCALSTORAGE_KEY,
} from '../../const/localstorage.const';
import storage from '../../lib/storage';

export interface AuthState {
  accessToken: string | null;
  keyId: string;
  hash: string;
  pinfl?: string;
  profile: UserData | null;
  setHash: (hash: string) => void;
  setKeyId: (keyId: string) => void;
  setAccessToken: (token: string) => void;
  setProfile: (userData: UserData | null) => void;
  setPinfl: (pinfl?: string) => void;
  reset: () => void;
  permissions: string[];
  setPermissions: (permissions: string[]) => void;
  hasPermission: (permission: string) => boolean;
}

let user: UserData | null = null;
const userRaw = storage.get(PROFILE_LOCALSTORAGE_KEY);
if (userRaw) {
  try {
    user = JSON.parse(userRaw) as UserData;
  } catch (e) {
    user = null;
    // Optionally log error
    console.error('Failed to parse user from localStorage', e);
  }
}

const accessToken = storage.get(ACCESSTOKEN_LOCALSTORAGE_KEY) ?? null;

const initialState = {
  keyId: '',
  hash: '',
  pinfl: undefined,
  accessToken,
  profile: null,
};

export const createAuthSlice: StateCreator<AuthState, [], [], AuthState> = (
  set,
  get,
) => ({
  ...initialState,
  setHash: (hash: string) => {
    set({
      hash,
    });
  },
  setKeyId: (keyId: string) => {
    set({
      keyId,
    });
  },
  setAccessToken: (accessToken: string) => {
    set({ accessToken });
  },
  setProfile: (userData: UserData | null) => {
    set({ profile: userData });
  },
  setPinfl: (pinfl: string | undefined) => {
    set({ pinfl: pinfl });
  },
  reset: () => {
    set(initialState);
  },
  permissions: user?.role?.permissions ?? [],
  setPermissions: (permissions: string[]) => {
    set({ permissions });
  },
  hasPermission: (permission: string) => {
    return get().permissions.includes(permission);
  },
});
